// Nhãn tiếng Việt cho khoá trường và giá trị thô mà quét Sheet sinh ra (diffRecords / diffProgress).
// Khoá lạ → trả nguyên khoá, không bịa nhãn.

const FIELD: Record<string, Record<string, string>> = {
  project: {
    category: 'Loại', active: 'Đang chạy', client: 'Chủ đầu tư', name: 'Tên dự án', location: 'Địa điểm', subcon: 'Thầu phụ',
    outputs: 'Sản phẩm', stages: 'Giai đoạn', startDate: 'Ngày bắt đầu', scope: 'Phạm vi', folder: 'Thư mục', reportUrl: 'Link báo cáo',
    deliverableUrl: 'Link bàn giao', members: 'Nhân sự',
  },
  profile: {
    name: 'Họ tên', shortName: 'Tên viết tắt', title: 'Chức vụ', contractType: 'Loại HĐ', role: 'Vai trò', email: 'Email', active: 'Đang làm',
  },
  attendance: { in: 'Giờ vào', out: 'Giờ ra', dayType: 'Loại ngày công' },
  phase: { order: 'Thứ tự', status: 'Trạng thái', plannedEnd: 'Hạn dự kiến', actualEnd: 'Hoàn thành thực tế', note: 'Ghi chú' },
  milestone: { status: 'Trạng thái', plannedDate: 'Ngày kế hoạch', actualDate: 'Ngày thực tế', note: 'Ghi chú' },
  payment: { sortOrder: 'Thứ tự', sharePercent: 'Tỷ lệ (%)', status: 'Trạng thái', dueDate: 'Hạn thanh toán', actualDate: 'Ngày thực tế' },
};

/** Giá trị liệt kê của cột `status` theo từng loại bản ghi. */
const STATUS: Record<string, Record<string, string>> = {
  phase: { pending: 'Chưa bắt đầu', progressing: 'Đang làm', done: 'Hoàn thành', paused: 'Tạm dừng', cancelled: 'Đã huỷ' },
  milestone: { scheduled: 'Đã lên lịch', submitted: 'Đã nộp', review: 'Đang duyệt', approved: 'Đã duyệt', rejected: 'Bị trả lại' },
  payment: { pending: 'Chưa đến hạn', invoiced: 'Đã xuất hoá đơn', paid: 'Đã thanh toán' },
};

const ENTITY: Record<string, string> = {
  project: 'Dự án', project_member: 'Thành viên dự án', phase: 'Giai đoạn', milestone: 'Mốc', payment: 'Đợt thanh toán', profile: 'Nhân sự', attendance: 'Chấm công',
};

export const entityLabel = (entity: string): string => ENTITY[entity] ?? entity;

export function fieldLabel(entity: string, field: string | null): string {
  if (!field) return '';
  return FIELD[entity]?.[field] ?? field;
}

export function valueLabel(entity: string, field: string | null, v: unknown): unknown {
  if (field === 'status' && typeof v === 'string') return STATUS[entity]?.[v] ?? v;
  if (typeof v === 'boolean') return v ? 'Có' : 'Không';
  // Nhân sự dự án: [{ code, shortName, role }] → tên viết tắt, chủ trì trước (thứ tự do bộ so sánh đã xếp).
  if (Array.isArray(v) && v.length > 0 && v.every((x) => x !== null && typeof x === 'object')) {
    return v.map((x: { shortName?: string; code?: string; name?: string }) => x.shortName || x.name || x.code || '').filter(Boolean).join(', ');
  }
  return v;
}
